// tslint:disable:only-arrow-functions
import { mergeMultipleConfigs } from '@epicuro-next/platform/dynamic-components-utils';

import { TypeForItemMediaPreviewInput } from '../../components';
import { createHorizontalScrollablePanelBoughtThisSeason } from '../common';

export const horizontalScrollablePanelBoughtThisSeason = mergeMultipleConfigs(
  createHorizontalScrollablePanelBoughtThisSeason(),
  [
    {
      id: 'root',
      data: {
        aggregationType: 1,
        panelName: 'BoughtThisSeasonPanel',
        panelStyleConstants: {
          page: 'pb',
          location: 'sp',
          type: 'hr',
          provider: 'neo',
          cssVariant: '001',
        },
        panelStyle: {
          values: [
            {
              provider: 'GlobalStoreProviderService',
              property: {
                paths: ['router.state.url'],
              },
            },
          ],
          transform: function ([routerUrl]: string[]) {
            if (
              routerUrl.includes('basket') &&
              !routerUrl.includes('basket-')
            ) {
              return 'SpotlightCBasket';
            }
            return 'SpotlightPBasket';
          }.toString(),
        },
        brandOrganisation: {
          values: [
            {
              provider: 'GlobalStoreProviderService',
              property: {
                path: 'session.siteId',
              },
            },
            {
              provider: 'GlobalStoreProviderService',
              property: {
                path: 'accounts.activeAccount.sites',
              },
            },
          ],
          transform: function ([siteId, sites]: [
            string,
            { siteId: string; brandId: string }[],
          ]) {
            return sites.find((site) => site.siteId === siteId);
          }.toString(),
        },
        brandId: {
          provider: 'self',
          property: 'brandOrganisation',
          transform: function (site: { siteId: string; brandId: string }) {
            return site.brandId;
          }.toString(),
        },
      },
    },
    {
      id: 'header-text',
      styles: {
        classes: ['d-flex', 'text-ellipsis'],
        style: {
          position: 'absolute',
          'z-index': '5',
          'writing-mode': 'vertical-rl',
          transform: 'rotate(180deg)',
          background: '#fff',
          'font-weight': 'bold',
          top: '0',
          bottom: '0',
          left: '0',
          'font-size': '.875rem',
          'min-width': '1.8rem',
          'box-sizing': 'content-box',
          'border-left': '1px solid rgb(221, 221, 221)',
          'border-top': '1px solid rgb(221, 221, 221)',
          display: 'flex',
          'flex-direction': 'column',
          'align-items': 'center',
          'justify-content': 'center',
          height: '100%',
        },
      },
    },
    {
      id: 'item-media-preview',
      inputs: {
        media: {
          transform: function (productDataArg: TypeForItemMediaPreviewInput) {
            return {
              ...productDataArg.media,
              url:
                productDataArg.product.articleImageUrl ??
                productDataArg.media.url,
            };
          }.toString(),
        },
      },
    },
    {
      id: 'scrollable-panel-container',
      styles: {
        classes: [
          'sp-hsp-bts', // unique
          'horizontal-scrollable-panel-container',
          'd-block',
          'position-relative',
        ],
        variables: {
          '--scroll-buttons-left-position': '2.5rem',
        },
        style: {
          'border-radius': 'var(--border-radius-lg, .25rem)',
          'box-shadow': 'none',
        },
        css: `.sp-hsp-bts .text-ellipsis .text-value { white-space: nowrap;overflow: hidden;text-overflow: ellipsis;height: 100%;text-align: center;} 
              .sp-hsp-bts .item-content-title {background-color: rgba(0, 0, 0, 70%);color: #fff;bottom: 0;padding-top: 0.125rem; padding-bottom: 0.125rem; font-size: 0.825rem;font-weight: 500;}
              .sp-hsp-bts atx-scroll-buttons {padding-left: calc(30px + 1rem);padding-right: 1rem;}
              .sp-hsp-bts {background:hsl(0deg 37% 87% / 35%);background: radial-gradient(circle,hsl(0deg 37% 87% / 35%) 0%, hsla(0, 0%, 100%, 1) 100%);background: -moz-radial-gradient(circle,hsl(0deg 37% 87% / 35%) 0%, hsla(0, 0%, 100%, 1) 100%);background: -webkit-radial-gradient(circle,hsl(0deg 37% 87% / 35%) 0%, hsla(0, 0%, 100%, 1) 100%);}
              .sp-hsp-bts .item-content-type {box-shadow: 0 7px 30px -10px rgba(var(--p-card-shadow, var(--color-brand-gray-700-rgb, 153, 153, 153)), 50%);transition: box-shadow 2s ease;overflow: hidden;}
              .sp-hsp-bts .item-content-type:hover {box-shadow: var(--box-shadow, 0 0.25rem 0.75rem rgba(#000, 7.5%)); }
              .sp-hsp-bts .item-content-type atx-image {transform: scale(0.8);transition: transform .3s ease-out;backface-visibility: hidden;}
              .sp-hsp-bts .item-content-type:hover atx-image {transform: scale(1);transition: transform .5s ease-out;}`,
      },
    },
    {
      id: 'scrollable-container',
      inputs: {
        wheelHorizontalScrollEnabled: true,
      },
    },
    {
      id: 'header-container',
      styles: {
        style: {
          'margin-left': '2rem',
        },
      },
    },
    {
      id: 'product-card-icons',
      if: ['EQ', [false, true]],
    },
  ],
);
